import { eur } from "@/lib/api";

export const MONTHS = ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dic"];
export const STATE = {
  chiuso: ["Chiuso", "bg-emerald-100 text-emerald-700"],
  in_corso: ["In corso", "bg-sky-100 text-sky-700"],
  previsto: ["Previsto", "bg-amber-100 text-amber-700"],
  non_operativo: ["Non operativo", "bg-slate-100 text-slate-500"],
};
export const SOURCE = {
  pickup: "pickup storico", anno_prec: "stesso mese anno prec.", occ_stimata: "occupazione stimata",
  reale: "reale", in_corso: "reale + confermato", chiusa: "struttura chiusa", non_operativo: "—",
};
export const pct = (v, d = 1) => (v == null ? "—" : `${Number(v).toLocaleString("it-IT", { maximumFractionDigits: d })}%`);
export const num = (v, d = 0) => Number(v || 0).toLocaleString("it-IT", { maximumFractionDigits: d });
export const signCls = (v) => (v > 0 ? "text-emerald-700" : v < 0 ? "text-rose-600" : "text-slate-500");
export const signed = (v) => `${v > 0 ? "+" : ""}${eur(v)}`;
